.outer-gif-image {
  &__picture {
    display: block;
    width: 100%;
  }

  &__img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
  }
}